import React, { Fragment } from "react";
import styles from "./InsightsSidebarList.module.scss";
import { SidebarItem } from "./InsightsSidebarListItem";
import Card from "components/core/Card/Card";
import * as DateIso from "@tiicker/util/lib/date-iso";

type Props = {
  headerTitle: string;
  insights: SidebarItem[];
};
export const InsightsSidebarList: React.FC<Props> = (props) => {
  return (
    <div className={styles.InsightsSidebarList}>
      <h3>{props.headerTitle}</h3>
      {props.insights.map((insight, i) => {
        return (
          <Fragment key={i}>
            <Card
              image={insight.heroImage}
              title={insight.title}
              badge="Hot Topic"
              url={insight.as}
              hideButton
              date={DateIso.formatLongMonthDayYear(
                DateIso.toIsoDate(insight.publishedDate)
              )}
            />
          </Fragment>
        );
      })}
    </div>
  );
};
